<template>
  <nav v-if="visibleItems.length" class="blog-table-of-contents" :aria-label="title">
    <h2 data-testid="blog-toc-title" class="toc-title">{{ title }}</h2>
    <ul class="toc-list">
      <li v-for="item in visibleItems" :key="item.id" class="toc-item">
        <a :href="`#${item.id}`" class="toc-link">{{ item.text }}</a>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type BlogTocItem = {
  id?: string;
  text?: string;
};

const props = withDefaults(defineProps<{
  items?: BlogTocItem[];
  title: string;
}>(), {
  items: () => []
});

const visibleItems = computed(() => props.items.filter((item) =>
  typeof item.id === 'string' && item.id.trim() && typeof item.text === 'string' && item.text.trim()
));
</script>

<style scoped lang="scss">
.blog-table-of-contents {
  position: sticky;
  top: calc(60px + #{$spacing-lg});
  width: 240px;
  padding: $spacing-lg;
  border: 1px solid $gray-200;
  border-radius: $border-radius-lg;
  background: $white;
  box-shadow: $shadow-sm;
}

.toc-title {
  margin: 0 0 $spacing-md;
  color: $gray-900;
  font-size: 1rem;
  line-height: 1.4;
}

.toc-list {
  display: grid;
  gap: $spacing-sm;
  margin: 0;
  padding: 0;
  list-style: none;
}

.toc-link {
  display: block;
  color: $primary-dark;
  font-size: 14px;
  line-height: 1.6;
  text-decoration: none;

  &:hover {
    color: $primary-color;
    text-decoration: underline;
  }
}

@media (max-width: 1199px) {
  .blog-table-of-contents {
    display: none;
  }
}
</style>
